
// private class variables
let SongManager_songIndex;

class SongManager {

  static getSongUrlFromId = songId => {
    if (!SongManager_songIndex) {
      return window.PUBLIC_URL + "/songs/twinkle/TwinkleTwinkle.csv";
    }
    let entry = SongManager_songIndex.songs[songId];
    return entry ? window.PUBLIC_URL + entry.filename : null;
  };

  static loadSongIndex = filename => {
    return fetch(window.PUBLIC_URL + filename)
      .then(response => response.json())
      .then(index => {
        SongManager_songIndex = index;
        return index;
      })
      .catch(error => console.log("load song index error: ", error));
  };
}

export default SongManager;
